import React from 'react';
import '../../assets/css/serviceoutagetitle.css';

export const ServiceTitle = ({Title}) => {
    return (
        <section className="main large-mw-none border-bottom" role="region">
            <div className="row large-padding-vert-zero">
                <div className="tiny-12 small-12 medium-12 large-12 columns text-left">
                    <h1 className="h2 service_title margin-bottom-micro"> {Title} </h1>
                </div>
            </div>
        </section>
    )
}


// WEBPACK FOOTER //
// ./src/components/modules/ServiceTitle.js